const readAmount = (value) => {
  if (value == null) return null;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value === "object") {
    return readAmount(value.amount ?? value.value ?? value.balance);
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const mapCycleConversion = (item) => {
  const tokensReceived =
    readAmount(item?.tokensReceived) ?? readAmount(item?.walletExtraCoinTransaction);
  const pointsConverted = readAmount(item?.pointsConverted);
  const cycle = item?.cycle == null || item?.cycle === "" ? null : Number(item.cycle);

  return {
    id: item?.id,
    cycle: Number.isFinite(cycle) ? cycle : null,
    date: item?.dateCreation || item?.untilConversion,
    conversionRate: item?.conversionRate,
    pointsConverted,
    tokensReceived,
    converted: Boolean(item?.converted),
    open: Boolean(item?.open),
    reference: `CV-${item?.id}`,
  };
};

export const sortConversionsDesc = (conversions) =>
  [...conversions].sort((left, right) => new Date(right.date || 0) - new Date(left.date || 0));

export const getPreviousCycleConversions = (conversions, currentCycle) =>
  sortConversionsDesc(conversions).filter((item) => {
    if (item.open) return false;
    if (currentCycle != null && item.cycle != null) return item.cycle !== Number(currentCycle);
    return true;
  });

export const getExcStatementConversions = (conversions) =>
  sortConversionsDesc(conversions).filter(
    (item) => item.converted || item.tokensReceived != null,
  );
